import type { SelectPageInfo } from "../common/types";

/**
 * select 页 mock 开关。
 * true：短路真实接口，直接喂 MOCK_PAGE_INFO 渲染，用于本地看页面。
 * 看完改回 false 即恢复真实接口。
 *
 * TODO: 联调期 mock，看完页面改回真实请求。
 */
export const USE_MOCK = false;

/**
 * 与 SelectPageInfo 契约对齐的 mock 渲染数据。
 * 字段对应 View.tsx 里实际消费的渲染点：
 * title/desc → select-header
 * content[] icon/content/limit → 列表项（图标/标题/副标题限额）
 * link/type → 点击跳转 openScheme
 */
export const MOCK_PAGE_INFO: SelectPageInfo = {
  title: "Transfer and Payment Limits",
  desc: "You can raise or lower the maximum amount for a single transfer or payment, and adjust it anytime as needed.",
  customerLinkUrl: "globalOneTravel://one/sofipo/web?url=https%3A%2F%2Fdsim438-api.intra.xiaojukeji.com%2Fd-server-ngw%2Fcs_global%2Fhelp%2Fhome-page.html%3FportalToken%3DCustomer_Menu_side_bar_1696851963660",
  content: [
    {
      icon: "https://s3-us01.didiglobal.com/silver-bullet-img/2026-03-24/N3v9-y/____.png",
      content: "Transfer Limit",
      limit: "Current Limit: $75,000.00",
      link: "globalOneTravel://one/sofipo/web?url=https%3A%2F%2Fdsim293-api.intra.xiaojukeji.com%2Fsf%2Flimit%2Fset%3Ftype%3Dtransfer%26source_page_name%3D1",
      type: "single_transfer",
    },
    {
      icon: "https://s3-us01.didiglobal.com/silver-bullet-img/2026-03-24/gzGUZX/__.png",
      content: "Payment Limit",
      limit: "Current Limit: $562.00",
      link: "globalOneTravel://one/sofipo/web?url=https%3A%2F%2Fdsim293-api.intra.xiaojukeji.com%2Fsf%2Flimit%2Fset%3Ftype%3Dpayment%26source_page_name%3D1",
      type: "single_payment",
    },
  ],
};
